import type { ReduxState } from "model/state"

export function selectModelId(state: ReduxState, dashboardId: string | null): string | null {
  if (dashboardId === null) return null
  return state.dashboard.model[dashboardId]?.modelId ?? null
}
